import React, { memo } from 'react';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section className="relative w-full min-h-[80vh] md:min-h-[600px] flex items-center justify-center overflow-hidden bg-ink" data-id="element-98">
      {/* Parallax Background */}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat bg-fixed" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/pwiaJpW6rE6Y62bFJXFLpT/mick-haupt-SUYNZe93z1Y-unsplash.jpg")'
    }} data-id="element-99" />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/65" data-id="element-100" />
      {/* Center darkening for headline legibility */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%)'
    }} data-id="element-101" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 flex flex-col items-center text-center py-12" data-id="element-102">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-heading text-5xl md:text-7xl lg:text-8xl text-white mb-6 uppercase tracking-wide max-w-4xl leading-none drop-shadow-[4px_4px_0px_rgba(0,0,0,1)]" data-id="element-103">
          Authentic Cards. <br data-id="element-104" />
          <span className="text-scarlet" data-id="element-105">Signed Helmets.</span> <br data-id="element-106" />
          Buckeye Built.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl font-bold text-white mb-10 max-w-2xl drop-shadow-[2px_2px_0px_rgba(0,0,0,1)]" data-id="element-107">
          Graded cards, autographed memorabilia, and game-ready collectibles.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center gap-6 w-full sm:w-auto mt-4" data-id="element-108">
          <a href="#shop" className="w-full sm:w-auto bg-scarlet text-white font-heading text-xl tracking-wider px-8 py-4 border-4 border-ink shadow-comic hover:shadow-comic-hover hover:translate-x-[4px] hover:translate-y-[4px] transition-all text-center min-h-[56px] flex items-center justify-center" data-id="element-109">
            Shop the Collection
          </a>
          <a href="#memorabilia" className="w-full sm:w-auto bg-white text-ink font-heading text-xl tracking-wider px-8 py-4 border-4 border-ink shadow-comic hover:shadow-comic-hover hover:translate-x-[4px] hover:translate-y-[4px] transition-all text-center min-h-[56px] flex items-center justify-center" data-id="element-110">
            New Arrivals
          </a>
        </motion.div>
      </div>
    </section>;
};